import { NgModule, APP_INITIALIZER } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { InteceptorsModule } from './interceptors/interceptors.module';
import { Store } from '@ngxs/store';
import { LocalStorageService } from './services/infrastructure/local-storage.service';
import { IAppSession } from './store/app.store.model';
import { CONSTANTS } from './utils';
import { AppStoreActions } from './store';

const appInitializerFn = (
  store: Store,
  localStorage: LocalStorageService
) => {
  return () => {
    const session = localStorage.get<IAppSession>(CONSTANTS.APP_SESSION_KEY);
    if (session) {
      store.dispatch(new AppStoreActions.Session.SetSessionFromStorage({ session }));
    }

  };
};

@NgModule({
  declarations: [
  ],
  imports: [
    InteceptorsModule,
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFn,
      multi: true,
      deps: [
        Store,
        LocalStorageService
      ]
    }
  ]
})
export class CoreModule { }
